import React, { useState,useMemo } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import endpoints from "../config";
import { useAuth } from "../context/AuthContext";
const CustomSegmentModal = ({
  show,
  onClose 
}) => {
  const [segment, setSegment] = useState({
    name: "",
    query: "",
    description: "",
    owner_team: "",
  });
  const {authToken} = useAuth();
  const [loading, setLoading] = useState(false);
 // Memoize headers so it doesn't change on every render
  const headers = useMemo(() => ({
    Authorization: `Bearer ${authToken}`
  }), [authToken]);
  const handleChange = (field, value) => {
    setSegment(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = async () => {
    if (!segment.name.trim() || !segment.query.trim()) {
      toast.warning("Segment name and query are required.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(endpoints.activation.segmentCreate, {
        name: segment.name,
        query_type: "custom",
        query: segment.query,
        description: segment.description,
        owner_team: segment.owner_team,
      }, { headers });
      toast.success("Custom segment created!");
      setSegment({
        name: "",
        query: "",
        description: "",
        owner_team: "",
      });
       
      onClose();
    } catch (error) {
        if (error.response?.data?.detail?.error) {
        toast.error(error.response.data.detail.error);
        } else {
        toast.error("Failed to create custom segment");
        }
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;
  return (
    <div className="modal show fade d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-between align-items-start">
  <h5 className="modal-title">Create Custom Segment</h5>
  <button
    type="button"
    className="close"
    onClick={onClose}
    disabled={loading}
    aria-label="Close"
    style={{ padding: '0.5rem', margin: '0', lineHeight: '1' }}
  >
    <span aria-hidden="true"><i className="fa fa-times"></i></span>
  </button>
</div>



          <div className="modal-body">
            <div className="mb-2">
              <label className="form-label">Segment Name</label>
              <input
                type="text"
                className="form-control"
                value={segment.name}
                onChange={e => handleChange("name", e.target.value)}
                disabled={loading}
              />
            </div>
            <div className="mb-2">
              <label className="form-label">Query</label>
              <textarea
                className="form-control"
                rows={4}
                value={segment.query}
                onChange={e => handleChange("query", e.target.value)}
                disabled={loading}
              />
            </div>
            <div className="mb-2">
              <label className="form-label">Description</label>
              <input
                type="text"
                className="form-control"
                value={segment.description}
                onChange={e => handleChange("description", e.target.value)}
                disabled={loading}
              />
            </div>
            <div className="mb-2">
              <label className="form-label">Owner Team</label>
              <input
                type="text"
                className="form-control"
                placeholder="marketing, developer, IT, etc."
                value={segment.owner_team}
                onChange={e => handleChange("owner_team", e.target.value)}
                disabled={loading}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-success"
              onClick={handleSave}
              disabled={loading}
            >
              {loading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                "Create Segment"
              )}
            </button>
            <button className="btn btn-secondary" onClick={onClose} disabled={loading}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomSegmentModal;


